import { baseApiUrl } from '@/utils/common/env.constants';
import {
  IMasterclassDescription,
  IMasterclassVisitUtm,
  IMasterclassDetails,
} from '@/interfaces/masterclassDescription';
import { randomId } from '@pwskills/rachnaui/utils';
import { get, post } from './index';

class MasterClassDesc {
  static async getMasterclassDescription(slug: string) {
    return get<IMasterclassDescription>(
      `/masterclass/${slug}?random_id=${randomId()}`,
      undefined,
      `${baseApiUrl}/v2`
    );
  }

  static async getMasterclassDescriptionDashboard(slug: string) {
    return get<IMasterclassDetails>(
      `/masterclass/${slug}?random_id=${randomId()}`,
      undefined,
      `${baseApiUrl}/v2`
    );
  }

  static async getMasterclassPageVisitNPF(data: IMasterclassVisitUtm, courseId: string) {
    return get<IMasterclassDescription>(
      `/masterclass/masterclass-visit-npf/${courseId}`,
      {
        params: {
          source: data?.utm_source,
          medium: data?.utm_medium,
          campaign: data?.utm_campaign,
        },
      },
      `${baseApiUrl}/v2`
    );
  }

  static registerToMasterclass(data: any, masterclassId: string, isFreeCheckout: boolean) {
    return post<any>(
      `/checkout/${masterclassId}`,
      {
        'g-recaptcha-response': data['g-recaptcha-response'],
      },
      {
        params: {
          method: !isFreeCheckout ? 'razorpay' : '',
          code: data?.coupon,
          source: data?.utm_source,
          medium: data?.utm_medium,
          campaign: data?.utm_campaign,
          sourceType: data?.sourceType,
        },
      },
      `${baseApiUrl}/v2`
    );
  }
}
export default MasterClassDesc;
